import { CheckCircleOutlined, CloseCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Title from "antd/es/typography/Title";
import { CodeEditor } from "components/UI/CodeEditor";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import TestConnectionSequenceStepResponse = App.Http.Responses.ConnectionSequenceStep.TestConnectionSequenceStepResponse;

interface TestResultProps {
    series: TestConnectionSequenceStepResponse["series"];
    resetTest: () => void;
}

export const TestResult: FC<TestResultProps> = ({ series, resetTest }) => {
    const { t } = usePaldockTranslation("forms.base-test");

    return (
        <div>
            <Button size="middle" className={"m-3 mb-0"} onClick={() => resetTest()}>
                <LeftOutlined /> {t("buttons.back_to_editor")}
            </Button>
            {Object.entries(series).map(([stepName, { autoResponse, isSuccess }]) => (
                <DrawerCollapsible
                    key={stepName}
                    title={
                        <Title level={4} className={"!mb-0"}>
                            {stepName}
                            {isSuccess ? (
                                <CheckCircleOutlined style={{ color: "green", marginLeft: 8 }} />
                            ) : (
                                <CloseCircleOutlined style={{ color: "red", marginLeft: 8 }} />
                            )}
                        </Title>
                    }
                >
                    <DrawerCollapsible title="Request">
                        <CodeEditor
                            className="!max-h-80 rounded-lg border"
                            id={`request-${stepName}`}
                            wrapEnabled
                            minLines={20}
                            maxLines={20}
                        >
                            {JSON.stringify(autoResponse.requestInfo, null, 2)}
                        </CodeEditor>
                    </DrawerCollapsible>

                    <DrawerCollapsible title="Response">
                        <CodeEditor
                            className="!max-h-80 rounded-lg border"
                            id={`response-${stepName}`}
                            wrapEnabled
                            minLines={20}
                            maxLines={20}
                        >
                            {JSON.stringify(autoResponse.responseInfo, null, 2)}
                        </CodeEditor>
                    </DrawerCollapsible>
                </DrawerCollapsible>
            ))}
        </div>
    );
};
